export default __webpack_public_path__ + "static/media/pink-wp.6f82a933.svg";